












































import { Vue, Component } from "vue-property-decorator";

import { SimpleInput as Simple } from "@netex/inputs";

import PageTitle from "@/components/common/PageTitle.vue";

import { ButtonTypes, IButtonData } from "@/services/interfaces";

import { personalModule } from "@/plugins/store-accessors";

enum DataProps {
  password = "password",
  passwordConfirm = "password-confirm",
}

interface InputElement extends Element {
  checkForErrors: () => boolean;
}

@Component({
  components: {
    Simple,
    PageTitle,
  },
})
export default class ResetPasswordForm extends Vue {
  error: boolean = false;

  get content() {
    return personalModule.getResetContent;
  }

  inputData: {
    [DataProps.password]: string;
    [DataProps.passwordConfirm]: string;
  } = {
    [DataProps.password]: "",
    [DataProps.passwordConfirm]: "",
  };

  buttonClickHandler(button: IButtonData): void {
    switch (button.type) {
      case ButtonTypes.link:
        this.redirect(button.link || "/");
        break;
      case ButtonTypes.submit:
        this.submit();
        break;
      default:
        break;
    }
  }

  redirect(link: string) {
    this.$router.replace({ path: link });
  }

  async submit() {
    if (!this.errorCheck()) {
      const data: any = {
        password: this.inputData[DataProps.password],
        password_confirmation: this.inputData[DataProps.passwordConfirm],
      };
      const res = await personalModule.sendNewPassword({
        url: "/api" + this.$route.path,
        data,
      });
      this.error = !!res.errors;
    }
  }

  errorCheck() {
    const errors: boolean[] = [];
    const refs = Object.keys(this.$refs);
    refs.forEach(ref => {
      const error = (this.$refs[ref] as InputElement).checkForErrors();
      if (error) errors.push(error);
    });
    return errors.length;
  }

  setValue(str: DataProps, val: string) {
    const data = Object.assign({}, this.inputData);
    data[str] = val;
    this.inputData = data;
  }

  handleLinks($event: any) {
    let target = $event.target;
    while (target && target.tagName !== "A") target = target.parentNode;
    if (target && target.href) {
      const url = new URL(target.href);
      const to = url.pathname;
      if (window.location.pathname !== to && $event.preventDefault) {
        this.$router.replace(to.replace("/api", ""));
      }
    }
  }
}
